import "./stylesMotorista.css";
import React from "react";
import { FaUserAlt, FaIdCard, FaTruck, FaCoins, FaClock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../ProgressBar";
import { format, toZonedTime } from "date-fns-tz";
import { addHours } from "date-fns";

const ListaMotorista = ({ listaMotoriista, maxHeight }) => {
  const navigate = useNavigate();

  const handleCardClick = (id) => {
    navigate(`/Motorista/${id}`);
  };

  const formatarDataHora = (datahora) => {
    const timeZone = "America/Sao_Paulo";
    const dataZoned = toZonedTime(datahora, timeZone);
    const dataSomada = addHours(dataZoned, 0);
    const formato = "dd/MM/yyyy HH:mm:ss";
    return format(dataSomada, formato);
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined) return "";
    if (value === 0) return "0,00";

    const stringValue = typeof value === "string" ? value : value.toString();
    const numericValue = parseFloat(stringValue.replace(",", "."));

    if (isNaN(numericValue)) return "";

    return new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);
  };

  return (
    <div
      className="card-container"
      style={{
        maxHeight: maxHeight || "65vh",
        overflowY: "auto",
      }}
    >
      {listaMotoriista.map((motorista) => (
        <div
          key={motorista.IDusuario}
          className="card"
          onClick={() => handleCardClick(motorista.IDusuario)}
        >
          <div className="card-content">
            <div className="card-row">
              <div className="card-info">
                <h3 className="driver-card-title">
                  <FaUserAlt style={{ marginRight: "8px" }} />
                  {motorista.nome +
                    " (ID. " +
                    String(motorista.IDusuario).padStart(6, "0") +
                    ")"}
                </h3>

                <div className="driver-card-grid">
                  <div className="driver-card-item">
                    <FaIdCard />
                    <span>ID. Carga</span>
                    <strong>{motorista.IDlote}</strong>
                  </div>
                  <div className="driver-card-item">
                    <FaClock />
                    <span>Placa</span>
                    <strong>{motorista.placa}</strong>
                  </div>
                  <div className="driver-card-item">
                    <FaTruck />
                    <span>Saida</span>
                    <strong>{formatarDataHora(motorista.datahora)}</strong>
                  </div>
                  <div className="driver-card-item">
                    <FaCoins />
                    <span>Vr. Carga</span>
                    <strong>R$ {formatNumber(motorista.ValorEntregas)}</strong>
                  </div>
                  <div className="driver-card-item">
                    <FaCoins />
                    <span>Vr. Entregue</span>
                    <strong>R$ {formatNumber(motorista.valorJaEntregue)}</strong>
                  </div>
                  <div className="driver-card-item">
                    <FaCoins />
                    <span>Vr. Restante</span>
                    <strong>
                      R${" "}
                      {formatNumber(
                        motorista.ValorEntregas - motorista.valorJaEntregue
                      )}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="card-progress">
                <div className="card-progress-box">
                  <ProgressBar
                    max={motorista.Nentregas}
                    value={motorista.NentregasRealizadas}
                    texto={"Andamento das visitas : "}
                  />
                </div>
                <div className="card-progress-box">
                  <ProgressBar
                    max={Math.round(motorista.VolumeTotal)}
                    value={Math.round(motorista.VolumeEntregue)}
                    texto={"Volume : "}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListaMotorista;
